import { shouldShowError } from './shouldShowError';
/**
 * Returns visible error that should be shown to the user.
 * Make sure that `props.internalData.error` is `string | undefined`, if it is not then do not use this helper method.
 * @param {object} props - Widget props.
 * @returns {string | undefined} Visible error or undefined.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getVisibleError(props) {
    var _a;
    if (props.internalData.error != null && typeof props.internalData.error !== 'string') {
        console.error('Incorrect usage of widget internalData.error, widget type: ' + props.config.type);
    }
    if (shouldShowError(props)) {
        return (_a = props.internalData.error) !== null && _a !== void 0 ? _a : props.error;
    }
    else {
        return undefined;
    }
}
